export default {
  namespaced: true,
  state: {
    expertRes: [],
    damageTypes: [],
    products: [],
    types: [],
    categories: [],
    cars: [],
    warranties: [],
    warranty: null,
    pdfFileUrl: null,
  },
  actions: {

    GetInfo({ commit, rootGetters, dispatch }) {
      return new Promise((resolve, reject) => {
        rootGetters.axl.post('warranty/api/warranty/create-info')
          .then((response) => {
            if (!response || !response.data) reject(new Error('no response data'));

            commit('setCreateInfo', response.data);
            resolve(response.data);
          })
          .catch((error) => {
            dispatch('HandleError', error, { root: true });
            reject(error);
          });
      });
    },
    GetList({ commit, rootGetters }, payload) {
      commit('setField', { name: 'warranties', value: [] });

      rootGetters.ax.post('warranty/api/warranty/by-profile', payload)
        .then((response) => {
          const { warranties } = response.data;
          commit('setField', { name: 'warranties', value: warranties });
        });
    },
    GetWarranty({ commit, rootGetters, dispatch }, payload) {
      commit('setField', { name: 'warranty', value: null });
      return new Promise((resolve, reject) => {
        rootGetters.axl.post('warranty/api/warranty/details', payload)
          .then((response) => {
            if (response && response.data) {
              commit('setField', { name: 'warranty', value: response.data.warranty });
              resolve(response.data);
            }
            reject(new Error('no response data'));
          })
          .catch((error) => {
            dispatch('HandleError', error, { root: true });
            reject(error);
          });
      });
    },

    prePrint({ rootGetters, dispatch }, payload) {
      return new Promise((resolve, reject) => {
        rootGetters.axl.post('warranty/api/warranty/pre-print', payload)
          .then((response) => {
            if (response && response.data) {
              resolve(response.data);
            }
            reject(new Error('no response data'));
          })
          .catch((error) => {
            dispatch('HandleError', error, { root: true });
            reject(error);
          });
      });
    },
  },
  mutations: {
    setField(state, payload) {
      state[payload.name] = payload.value;
    },
    setCreateInfo(state, payload) {
      state.expertRes = payload.expert_res || [];
      state.damageTypes = payload.damage_type || [];
      state.products = payload.products || [];
      state.types = payload.types || [];
      state.categories = payload.categories || [];
      state.cars = payload.cars || [];
      state.pdfFileUrl = payload.pdf_file_url || null;
    },
  },
};
